import React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import Listlayananabooking from "./Listlayananabooking";
import Combukti from "./Combukti";
import Swal from "sweetalert2";
import Loadlapanganbooking from "../skeleton/Loadlapanganbooking";

export default function Databookinglapangan() {
  const [booking, setBooking] = useState([]);
  const [load, setLoad] = useState(false);
  const [valtgl, setValtgl] = useState("");
  const urlapi = process.env.REACT_APP_BASE_URL;

  const date = new Date();
  let tgl = new Date();
  let format_tgl =
    tgl.getFullYear() +
    "-" +
    ("0" + (date.getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + tgl.getDate()).slice(-2);

  const getData = async () => {
    try {
      const response = await axios.get(
        urlapi + "Databookinglapangan?iduser=" + localStorage.getItem("id")
      );
      setBooking(response.data);
    } catch (error) { }
  };

  const getData2 = async (e) => {
    try {
      const response = await axios.get(
        urlapi +
        "Databookinglapangan?iduser=" +
        localStorage.getItem("id") +
        "&&tglbooking=" +
        e
      );
      setBooking(response.data);
      setLoad(true);
    } catch (error) { }
  };

  const notify = () => {
    toast.success("Booking berhasil dihapus !", {
      position: toast.POSITION.TOP_CENTER,
    });
  };

  const deleteData = async (id) => {
    await axios
      .post(urlapi + "Databookinglapangan", {
        id: id,
      })
      .then((response) => {
        getData();
        Swal.fire({
          title: "Yess",
          text: "Data booking berhasil di hapus",
          icon: "success",
          showConfirmButton: false,
          timer: 1000,
        });
      });
  };

  const handlecaridata = async (e) => {
    setValtgl(e);
    setLoad(false);
    getData2(e);
  };

  const btnLayanan = () => {
    Swal.fire({
      title: "Opss",
      text: "Fitur tambah layanan anda tidak tersedia",
      icon: "warning",
      confirmButtonColor: "#3085d6",
      showConfirmButton: false,
      timer: 1000,
    });
  };

  const getStatusInfo = (status) => {
    if (status == 200) {
      return {
        label: "Berhasil",
        badge: "booking-status success",
        icon: "fa-circle-check",
        color: "#28a745",
      };
    } else if (status == 201) {
      return {
        label: "Menunggu Persetujuan",
        badge: "booking-status pending",
        icon: "fa-hourglass-half",
        color: "#f39c12",
      };
    } else {
      return {
        label: "Ditolak",
        badge: "booking-status rejected",
        icon: "fa-circle-xmark",
        color: "#e74c3c",
      };
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setLoad(true);
      getData();
    }, 2000);
  }, []);

  return (
    <div className="booking-data">
      <div className="booking-data-header">
        <div className="booking-data-header-icon">
          <i className="fas fa-ticket-alt"></i>
        </div>
        <div>
          <h5 className="fw-bold mb-1">Booking Saya</h5>
          <small className="text-white-50">
            Kelola jadwal booking lapangan anda
          </small>
        </div>
      </div>

      {load == true ? (
        <div>
          <div className="booking-search">
            <div className="booking-search-label">
              <i className="fas fa-magnifying-glass"></i>
              Cari berdasarkan tanggal booking
            </div>
            <div className="booking-search-input">
              <i className="fas fa-calendar-alt"></i>
              <input
                name="tgl"
                type="date"
                value={valtgl}
                onChange={(e) => handlecaridata(e.target.value)}
              />
            </div>
          </div>

          {booking == "" ? (
            <div className="booking-empty">
              <div className="booking-empty-icon">
                <i className="fas fa-calendar-times"></i>
              </div>
              <h6 className="fw-bold mt-3">Hay {localStorage.getItem("nama")}</h6>
              <p className="text-secondary">
                Data booking anda kosong, silahkan booking sekarang
              </p>
            </div>
          ) : (
            <div className="booking-list">
              {booking.map((data, index) => {
                const status = getStatusInfo(data.status_pembayaran);
                return (
                  <div className="booking-card" key={index}>
                    <div className="booking-card-top">
                      <div className="booking-card-lapangan">
                        <span className="booking-card-icon">
                          <i className="fas fa-futbol"></i>
                        </span>
                        <div>
                          <div className="fw-bold booking-lapangan-name">
                            {data.lapangan}
                          </div>
                          <span className={status.badge}>
                            <i className={`fas ${status.icon}`}></i>{" "}
                            {status.label}
                          </span>
                        </div>
                      </div>
                      <div className="booking-card-top-actions">
                        {/* <span className="booking-kode">{data.kode_book2}</span> */}
                        {data.status_pembayaran != 200 ? (
                          <span
                            className="booking-card-delete"
                            onClick={() => deleteData(data.id)}
                            title="Cancel booking"
                          >
                            <i className="fas fa-trash-alt"></i>
                          </span>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>

                    <div className="booking-card-info">
                      <div className="booking-info-row">
                        <span className="booking-info-chip">
                          <i className="fas fa-clock"></i> {data.jam_booking} WIB
                        </span>
                        <span className="booking-info-chip">
                          <i className="fas fa-calendar-day"></i> {data.tgl}
                        </span>
                        <span className="booking-info-chip">
                          <i className="fas fa-shield-halved"></i> {data.team}
                        </span>
                      </div>
                      <div className="booking-tanggal">
                        Booking :{" "}
                        {format_tgl == data.tgl
                          ? "Hari ini"
                          : data.tgl_booking}
                      </div>
                    </div>

                    <div className="booking-card-services">
                      <Listlayananabooking kodebooking={data.kode_booking} />
                    </div>

                    <div className="booking-card-footer">
                      <div className="booking-card-buttons">
                        {data.status_pembayaran == 400 ? (
                          <button
                            onClick={() => btnLayanan()}
                            className="booking-btn-main"
                          >
                            <i className="fas fa-plus-circle"></i> Tambah Layanan
                          </button>
                        ) : (
                          <Link
                            to={`/layanan/${data.kode_booking}/${data.kode_book2}`}
                            className="booking-btn-main"
                          >
                            <i className="fas fa-plus-circle"></i> Tambah Layanan
                          </Link>
                        )}
                        <Combukti kodebooking={data.kode_booking} />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      ) : (
        <div>
          <Loadlapanganbooking />
          <Loadlapanganbooking />
          <Loadlapanganbooking />
        </div>
      )}
      <ToastContainer />
    </div>
  );
}
